import React from 'react';

import cx from 'classnames';
import s from './SecondaryMenu.css';

const SecondaryMenuListItem = ({ className, children, id, active, handleClick }) => {
  const isActive = active ? s.active : '';

  return (
    <div
      id={id}
      className={cx(s.menuItem, className, isActive)}
      role="button"
      onClick={handleClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          handleClick(e);
        }
        if (e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          handleClick(e);
        }
      }}
      tabIndex={0}
    >
      {children}
      <i className={cx(s.arrow)} aria-hidden="true" />
    </div>
  );
};

export default SecondaryMenuListItem;



// WEBPACK FOOTER //
// ./src/components/SecondaryMenu/SecondaryMenuItem.js